/**
 * Description component.
 */
import Header from '@components/sections/description/descriptionHeader';
import Content from '@components/sections/description/descriptionContent';
import DescriptionContext from '@shared/components/utils/context/descriptionContext';
import useDescription from './useDescription';
import { ContextType } from '@shared/types/enums/context';
import { memo } from 'react';

/**
 * Description props.
 */
interface Props {
  type?: ContextType;
}

/**
 * Displays the description of the currently focused asset in a rail.
 */
function Description({ type = ContextType.MAIN }: Props) {
  const context = useDescription(type);
  return (
    <DescriptionContext.Provider value={context}>
      {context.display ? (
        <>
          <Header />
          <Content />
        </>
      ) : null}
    </DescriptionContext.Provider>
  );
}

export default memo(Description);
